'use client'
import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'
import { usePathname, useRouter } from 'next/navigation'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Tabs({ basePath, isPreview, id }) {
  const tabs = [
    { name: 'Overview', href: 'overview', current: false },
    { name: 'Team', href: 'team', current: false },
    { name: 'Updates', href: 'updates', current: true },
    { name: 'Documents', href: 'documents', current: false },
    { name: 'Startup Video', href: 'startup-video', current: false },
  ]
  const { user } = useAuth()
  const pathname = usePathname()
  const router = useRouter()
  const updateID = null
  const goTo = (url) => {
    if (!isPreview) {
      router.push(url)
    }
  }

  function renderTabsLinks() {
    const html = []
    tabs?.forEach((tab) => {
      let url = `/investors/${id}/${tab.href}/${
        tab.href == 'updates' && updateID ? updateID : ''
      }`
      if (user?.isAdmin) {
        url = `${user?.isAdmin ? '/dashboard' : ''}/investors/${id}/${
          tab.href
        }/${tab.href == 'updates' && updateID ? updateID : ''}`
      } else if (basePath) {
        url = `/investors${basePath}/${tab.href}/${
          tab.href == 'updates' && updateID ? updateID : ''
        }`
      }
      if (isPreview && tab.name == 'Updates') {
        return
      }
      html.push(
        <a
          key={tab.name}
          className={classNames(
            pathname?.includes(tab.href)
              ? 'bg-[#155EEF] text-white'
              : ' text-white hover:text-white hover:bg-[#155EEF]',
            'whitespace-nowrap h-[36px] flex items-center px-2 justify-center rounded px-1 font-[500] text-sm mr-8 ',
            `${isPreview ? '' : 'cursor-pointer'}`,
          )}
          aria-current={tab.current ? 'page' : undefined}
          onClick={() => goTo(url)}
        >
          {tab.name}
        </a>,
      )
    })
    return html
  }
  return (
    <div className="z-20 pt-2 pb-5 border-t border-[#424242] sm:pb-0">
      <div className="mt-3 sm:mt-4">
        <div className="relative px-4 lg:px-8 m-auto max-w-container">
          <nav className="flex flex-wrap -mb-px">{renderTabsLinks()}</nav>
        </div>
      </div>
    </div>
  )
}
